import styled from "@emotion/styled";
import { breakpoints } from "@trustpilot/businessapp-patternlibrary";
import { Button, Typography, Icon } from "@trustpilot/constellation-components";

export const UserIconInitials = styled.span`
  font-size: 16px;
  font-weight: bold;
  line-height: 120%;
  letter-spacing: -0.17px;
`;
export const UserIcon = styled(Button)({
  padding: "0 !important",
  backgroundColor: "#04DA8D",
  color: "#1C1C1C",
  borderRadius: "100%",
  height: "44px !important",
  width: "44px !important",
  minWidth: "44px !important",
  ["&:hover"]: {
    backgroundColor: "#05f69f",
    color: "#1C1C1C",
  },

  ["&:active, &:focus"]: {
    border: "1.5px solid #1C1C1C !important",
    color: "#1C1C1C",
    ["&:hover"]: {
      backgroundColor: "#05f69f",
      color: "#1C1C1C",
    },
  },
  [`@media (max-width: ${breakpoints.small}px)`]: {
    height: "40px !important",
    width: "40px !important",
    minWidth: "40px !important",
    ["&:active, &:focus"]: {
      border: "3px solid #FFFFFF !important",
    },
  },
});

export const StyledLogOutContainer = styled.div({
  borderTop: `solid 1px var(--divider-subtle)`,
  minWidth: 100,
  padding: 16,
});

export const StyledProfile = styled.section({
  borderBottom: `1px solid var( --divider-subtle)`,
  padding: 16,
  display: "grid",
});

export const StyledTypography = styled(Typography)(({ fontSize, marginBottom }) => ({
  fontSize,
  marginBottom,
}));

export const StyledAvatar = styled.div({
  backgroundColor: "#04DA8D",
  color: "#1C1C1C",
  borderRadius: "100%",
  height: "40px !important",
  width: "40px !important",
  minWidth: "40px !important",
  fontStyle: "normal !important",
  display: "flex",
  justifyContent: "center",
  paddingTop: 7.5,
  fontWeight: "bold",
  marginBottom: 16,
});

export const StyledIcon = styled(Icon)({
  marginBottom: 4,
});
